import * as yup from 'yup'

export const validationSchema = yup.object({
  liveFrom: yup.date().min(new Date(), 'Must be a date in the future.').required(),
  addPassword: yup.boolean(),
  password: yup.string().when('addPassword', {
    is: true,
    then: (schema) => schema.required(),
  }),
})
